export default __webpack_public_path__ + "static/media/OCGO-slider3.50ff83f9.jpg";